import { object, string, boolean } from "yup";
import type { CompanyValues } from "@companies/types/company";

const companyValidationSchema = object<CompanyValues>({
    nombre: string().required("El nombre de la empresa/sociedad es requerido"),
    estatus: boolean()
})

export default companyValidationSchema;